import { html } from 'lit';
import { ShieldCheck } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-shield-check')
export class PdsIconShieldCheck extends PdsIcon {
  @state()
  icon = ShieldCheck;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
